'use strict';

import React from 'react';
import BaseItem from './BaseFlexItem';
import Contacts from './Items/Contacts';
import Slider from './Items/Slider';
import Address from './Items/Address';
import Price from './Items/Price';
import Land from './Items/Land';
import Controls from './Items/Controls';
import Description from './Items/Description';

class SaleLands extends BaseItem {
  render () {
    const {
      user,
      domain,
      onUpdateFilter,
      eventMapModal,
      eventAddFavorites,
      eventRemoveFavorites,
      eventOpenCommentForm,
      eventOpenClaimForm,
      eventShowContacts,
      eventClickAnnouncement,
      eventAddFavoritesForCian,
      eventRemoveFavoritesForCian
    } = this.props;
    return (
      <div onClick={() => eventClickAnnouncement(this.rawItem)} className={'realty-item ' + this.className}>
        <a className='link' href={this.item.getLink()} target='_blank'>
          <div className='flex-item__container'>
            <div className='flex-item flex-item__slider'>
              <Slider
                item={this.item}
                user={user}
              />
            </div>
            <div className='flex-item flex-item__properties'>
              <div className='flex flex-between properties__main-info upper-side'>
                <div className='left-side'>
                  <Address
                    item={this.item}
                    domain={domain}

                    eventMapModal={eventMapModal}
                  />
                </div>
                <div className='right-side'>
                  <Price
                    item={this.item}
                  />
                  <Land
                    item={this.item}
                  />
                </div>
              </div>
              <div className='lower-side'>
                <div className='properties__description'>
                  <Description
                    item={this.item}
                    user={user}
                  />
                </div>
                <div className='properties__controls'>
                  <Controls
                    item={this.item}
                    rawItem={this.rawItem}
                    user={user}

                    eventAddFavorites={eventAddFavorites}
                    eventRemoveFavorites={eventRemoveFavorites}
                    eventAddFavoritesForCian={eventAddFavoritesForCian}
                    eventRemoveFavoritesForCian={eventRemoveFavoritesForCian}
                    eventOpenCommentForm={eventOpenCommentForm}
                    eventOpenClaimForm={eventOpenClaimForm}
                  />
                </div>
              </div>
            </div>
            <div className='flex-item flex-item__contacts'>
              <Contacts
                item={this.item}
                rawItem={this.rawItem}
                user={user}
                onUpdateFilter={onUpdateFilter}
                eventShowContacts={eventShowContacts}
              />
            </div>
          </div>
        </a>
      </div>
    );
  }
}

export default SaleLands;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/FlexItems/SaleLands.jsx